import { useSearchParams } from 'react-router-dom';
import DashboardLayout from '../../components/DashboardLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Badge } from '../../components/ui/badge';
import { useAuth } from '../../context/AuthContext';
import { MyFavoritesPanel } from './MyFavorites';
import { MyJobOffersPanel } from './MyJobOffers';
import { Heart, Briefcase, FolderOpen } from 'lucide-react';

const VALID_TABS = ['favoris', 'offres'];

export default function MyDocuments() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { hasModule } = useAuth();

  const tabParam = searchParams.get('tab');
  const activeTab = VALID_TABS.includes(tabParam) ? tabParam : 'favoris';

  const handleTabChange = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <DashboardLayout>
      <div className="w-full">
        <div className="mb-8">
          <p className="text-sm font-medium text-[hsl(var(--primary))] mb-2 flex items-center gap-2">
            <FolderOpen className="w-4 h-4" />
            Espace documents
          </p>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Mes documents</h1>
          <p className="text-slate-600">
            Retrouvez vos favoris et offres d&apos;emploi au même endroit.
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="w-full sm:w-auto h-auto flex flex-wrap gap-1 bg-muted/50 p-1.5 mb-6 rounded-xl border border-border shadow-soft">
            <TabsTrigger value="favoris" className="gap-2 rounded-lg data-[state=active]:bg-card data-[state=active]:shadow-soft" data-testid="documents-tab-trigger-favoris">
              <Heart className="w-4 h-4" />
              Mes favoris
            </TabsTrigger>
            <TabsTrigger value="offres" className="gap-2 rounded-lg data-[state=active]:bg-card data-[state=active]:shadow-soft" data-testid="documents-tab-trigger-offres">
              <Briefcase className="w-4 h-4" />
              Mes offres
              {!hasModule('job_offer_publisher') && (
                <Badge className="text-[10px] px-1.5 bg-amber-100 text-amber-800">PRO</Badge>
              )}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="favoris">
            <MyFavoritesPanel />
          </TabsContent>

          <TabsContent value="offres">
            <MyJobOffersPanel />
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
}
